import { ScrollView, Text, View } from 'react-native';
import { useIsFocused } from 'expo-router';
import { trpc } from '../../lib/trpc';
import {
  AccountConnectionsManager,
  AiIntegrationsCard,
  Card,
  ConnectionErrorBanner,
  GoogleSheetsIntegrationCard,
  PageContainer,
  PageHeader,
  WebHead,
} from '../../components';
import { useIsDesktop } from '../../hooks/useIsDesktop';

export default function IntegrationsScreen() {
  const isDesktop = useIsDesktop();
  const isFocused = useIsFocused();
  const householdQ = trpc.households.get.useQuery(undefined, { enabled: isFocused });
  const isDemo = householdQ.data?.isDemo ?? false;

  return (
    <>
      <WebHead><title>Integrations - Per Diem</title></WebHead>
      <ScrollView className="flex-1 bg-canvas dark:bg-canvas-dark">
        <ConnectionErrorBanner />
        <PageContainer className={isDesktop ? '' : 'p-4'} size="narrow">
          <PageHeader
            title="Integrations"
            subtitle="Manage connected accounts, exports, and AI assistant access"
            closeTo="/(app)"
          />
          <View className="gap-4">
            {isDemo ? (
              <Card>
                <Text className="text-sm font-semibold text-amber-900 dark:text-amber-100">
                  Read-only demo account
                </Text>
                <Text className="mt-1 text-sm text-amber-800 dark:text-amber-200">
                  Account linking, exports, and AI permission changes are disabled in demos.
                </Text>
              </Card>
            ) : null}

            <AccountConnectionsManager isDemo={isDemo} />
            <GoogleSheetsIntegrationCard isDemo={isDemo} />
            <AiIntegrationsCard isDemo={isDemo} />
          </View>
        </PageContainer>
      </ScrollView>
    </>
  );
}
